export const SET_CAMPUSES_VALUE = "SET_CAMPUSES_VALUE";
export const SET_ACCESSION_RESPONSIBLE = "SET_ACCESSION_RESPONSIBLE";
export const SET_ACCESSION_STUDENT = "SET_ACCESSION_STUDENT";
export const LOAD_THEME = "LOAD_THEME";
